import {
  getJobCategories,
  getJobIdentities,
  getJobDepartments,
  getJobsByParameters,
  getJobById

} from '~api/jobs'

import {
  getRegions,
  getSubregionByRegionId
} from '~api/places'

export const state = () => ({
  queryString: {
    area: 0,
    category: 0,
    city: 0,
    department: 0,
    identity: 0,
    keywords: '',
    query: ''
  },
  categories: [],
  identities: [],
  departments: [],
  regions: [],
  // subregions: [],
  jobs: {
    '1': []
  },
  pages: {},
  currentPage: 1,
  currentJobId: null,
  currentJobDetails: {},
  currentJobEnterprise: {}
})

export const getters = {
  currentPageGetter: state => state.currentPage,
  isPageRequested: state => (page) => Object.keys(state.jobs).includes(`${page}`),
  allPageJobsGetter: state => state.jobs,
  currentPageJobsGetter: state => state.jobs[`${state.currentPage}`],
  isTheSameQueryString: state => (newParams) => (JSON.stringify(state.queryString) === JSON.stringify(newParams)),
  categoriesGetter: state => state.categories,
  identitiesGetter: state => state.identities,
  departmentsGetter: state => state.departments,
  regionsGetter: state => state.regions,
  // subregionsGetter: state => Object.keys(state.subregions).includes(`${state.currentRegionId}`) ? state.subregions[`${state.currentRegionId}`] : [],
  pageGetter: state => state.pages,
  currentJobDetailsGetter: state => state.currentJobDetails,
  currentJobEnterpriseGetter: state => state.currentJobEnterprise
}

export const actions = {
  async getCategories ({
    commit, getters
  }) {
    if (getters.categoriesGetter.length) {
      return getters.categoriesGetter
    }
    const data = await getJobCategories()
    commit('setCategories', data)
    return data
  },
  async getIdentities ({
    commit, getters
  }) {
    if (getters.identitiesGetter.length) {
      return getters.identitiesGetter
    }
    const data = await getJobIdentities()
    commit('setIdentities', data)
    return data
  },
  async getDepartments ({
    commit, getters
  }) {
    if (getters.departmentsGetter.length) {
      return getters.departmentsGetter
    }
    const data = await getJobDepartments()
    commit('setDepartments', data)
    return data
  },
  async getRegions ({
    commit, getters
  }) {
    if (getters.regionsGetter.length) {
      return getters.regionsGetter
    }
    const data = await getRegions()
    commit('setRegions', data)
    return data
  },
  async getSubregions ({
    commit, getters
  }, regionId) {
    commit('setCurrentRegionId', regionId)

    const response = await getSubregionByRegionId(regionId)
    commit('setSubregions', response)
    return response
  },
  async getJobsBy ({
    dispatch,
    commit,
    getters,
    state
  }, params) {
    const response = await getJobsByParameters(params)

    const {
      jobs,
      pages
    } = response
    commit('setCurrentJobs', jobs)
    commit('setCurrentJobsPage', pages)

    return response
  },
  async getJobDetailsById ({ commit, getters }, id) {
    if (state.currentJobId === id) {
      return getters.currentJobDetailsGetter
    }
    commit('setCurrentJobId', id)
    const job = await getJobById(id)
    commit('setCurrentJobDetails', job)
    commit('setCurrentJobEnterprise', job.job_enterprise)
    return job
  },
  updateQueryString ({ commit }, queries) {
    commit('setQueryString', queries)
  }
}

export const mutations = {
  clearQueryString (state) {
    state.queryString = {}
  },
  setCategories (state, payload) {
    state.categories = payload
  },
  setIdentities (state, payload) {
    state.identities = payload
  },
  setDepartments (state, payload) {
    state.departments = payload
  },
  setRegions (state, payload) {
    state.regions = payload
  },
  // setSubregions (state, payload) {
  //   state.subregions = Object.assign({}, state.subregions, {
  //     [`${state.currentRegionId}`]: payload
  //   })
  // },
  setCurrentRegionId (state, payload) {
    state.currentRegionId = payload
  },
  resetJobs (state) {
    state.jobs = {
      '1': []
    }
  },
  setCurrentJobs (state, payload) {
    state.jobs[`${state.currentPage}`] = payload
  },
  setCurrentPage (state, payload) {
    state.currentPage = payload
  },
  setCurrentJobsPage (state, payload) {
    state.pages = payload
  },
  setTotalPages (state, payload) {
    state.totalPages = payload
  },
  setCurrentJobId (state, payload) {
    state.currentJobId = payload
  },
  setCurrentJobDetails (state, payload) {
    state.currentJobDetails = payload
  },
  setCurrentJobEnterprise (state, payload) {
    state.currentJobEnterprise = payload
  },
  setQueryString (state, payload) {
    state.queryString = payload
  }
}
